import React, { Component } from 'react'
import MenuItem from '../components/MenuItem'
import { Plugins as _Plugins } from './__styles__'


export default function Plugins({ systems = [], onClick = () => { }, selectedIdx }) {
    return (
        <_Plugins>
            {systems.map((system, idx) => <MenuItem key={`${system}-${idx}`} title={system} onClick={() => onClick(system, idx)} isSelected={selectedIdx === idx} />)}
        </_Plugins>
    )
}

